import { createPointGesture } from './pointFactory.js';
export default createPointGesture('up');
